
import Events from '../Events';
import GHGeometryObject from './GHGeometryObject';

export default class GHSliderObject extends GHGeometryObject {
  constructor (ghObject, digits, min, max, value, interval) {
    super(ghObject);

    this.digits = Number(digits);
    this.min = Number(min);
    this.max = Number(max);
    this.__value = Number(value);
    this.interval = Number(interval);
  }

  get value () {
    return this.__value;
  }

  set value (v) {
    this.__value = v;
  }

  change (v) {
    this.value = v;
    this.emit(Events.UI_CHANGE, this);
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/GHSliderObject.js